import { gql } from "@apollo/client";

import { childResources } from "../fragments";

export const orgChildResources = gql`
    query orgChildResources($limit: Int!, $cursor: String!, $kind: ResourceKind!, $parentId: String!) {
        childResources(input: { limit: $limit, cursor: $cursor, kind: $kind, parentId: $parentId }) {
            ...ChildResourcesAll
        }
    }
    ${childResources}
`;
